import WidgetLoader from 'common/components/loaders/WidgetLoader'
import PageContainer from 'common/components/PageContainer'
import Widget from 'common/components/Widget'

import { useGetSdkTagsQuery } from './api'
import BlockedEvents from './BlockedEvents'
import TagList from './TagList'

const SdkSettings = () => {
  const { data: tags, isLoading, isError } = useGetSdkTagsQuery()

  return (
    <PageContainer className="max-w-318 sm:mx-auto pt-10 sm:pl-4">
      {/* Widget 1 — Tags */}
      <Widget
        data-cy="sdk-tags-widget"
        data-testid="sdk-tags-widget"
        className="mb-6"
      >
        {isLoading ? (
          <WidgetLoader />
        ) : (
          <TagList tags={tags} isError={isError} onTagCreated={() => {}} />
        )}
      </Widget>

      {/* Widget 2 — Blocked conversion events */}
      <Widget
        data-cy="sdk-blocked-events-widget"
        data-testid="sdk-blocked-events-widget"
        className="mb-6"
      >
        <BlockedEvents />
      </Widget>
    </PageContainer>
  )
}

export default SdkSettings
